import React from "react";
import { Spin } from "antd";
import Localize from "components/service/localize";

import "./app-content.css";

const AppContentStatus = ({ resource }) => {
    if (resource.loading) {
        return (
            <div className="app-content-status" role="status">
                <Spin size="small" />
                <Localize>GLOBAL.Text_Loading</Localize>
            </div>
        );
    }
    if (resource.error) {
        return (
            <div className="app-content-status" role="alert">
                <Localize>{resource.loaded ? "APP_CONTENT.Text_RefreshError" : "APP_CONTENT.Text_LoadError"}</Localize>
                <button type="button" className="app-content-retry" onClick={resource.refresh}>
                    <Localize>APP_CONTENT.Button_Retry</Localize>
                </button>
            </div>
        );
    }
    return null;
};

export default AppContentStatus;
